import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { NavLink, Route } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import { ListRegistrationParkingRequests } from '@admin/registration-parking-requests/views/ListRegistrationParkingRequests';
import { ListRegistrationParkingStickers } from '@admin/registration-parking-stickers/views/ListRegistrationParkingStickers';

import { selectEvent } from '../../../redux/preferences/selectors';
import { REGISTRATIONS_ACTIONS } from '../../../redux/registrations/actions';
import { getRegistration } from '../../../services/api/registrations';
import AdminSubHeader from '../../layouts/partials/AdminSubheader';
import RegistrationAccessVouchers from './pages/AccessVouchers';
import RegistrationBase from './pages/Base';
import RegistrationCatering from './pages/Catering';
import RegistrationCrewMembers from './pages/CrewMembers';
import FrequentPassages from './pages/FrequentPassages';
import RegistrationParkingStickers from './pages/ParkingStickers';
import RegistrationParkingVouchers from './pages/ParkingVouchers';
import RegistrationProfileLimits from './pages/ProfileLimits';

class RegistrationsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      registration: undefined,
    };

    this._updateRegistration = this._updateRegistration.bind(this);
  }

  static propTypes = {
    match: PropTypes.object,
    event: PropTypes.object,
  };

  UNSAFE_componentWillMount() {
    this._updateRegistration();
  }

  componentDidUpdate(nextProps) {
    if (Number(nextProps.match.params.id) !== this.state.registration?.id) {
      this._updateRegistration();
    }
  }

  _updateRegistration() {
    getRegistration(this.props.match.params.id, {
      include:
        'crew-member-material-templates.crew-member-material,parkings,registration-profiles,company,departments,registration-profiles.profile,event,material-categories,allowed-catering-options',
    }).then((registration) => {
      this.setState({
        registration,
      });
    });
  }

  render() {
    const { registration } = this.state;
    if (registration) {
      const breadcrumbs = [
        {
          title: 'Registrations',
          to: '/admin/registrations',
        },
      ];

      const { event } = this.props;

      const LimitsComplete =
        registration && ['created', 'crewQuantityRequested'].indexOf(registration.status.name) === -1;
      const statusDependendClassNames = classNames('nav-item', 'm-tabs__item', {
        'm-tabs__item--disabled': !LimitsComplete,
      });

      return (
        <Fragment key={registration.id}>
          <AdminSubHeader
            title="Edit Registration"
            subtitle={registration ? registration.company.name : undefined}
            badge={registration?.frozenAt ? 'Frozen' : false}
            key="subheader"
            breadcrumbs={breadcrumbs}
          />
          <div className="m-content" key="content">
            <div>
              <div className="m-portlet m-portlet--tabs">
                <div className="m-portlet__head">
                  <div className="m-portlet__head-tools">
                    <ReactTooltip />
                    <ul className="nav nav-tabs m-tabs-line m-tabs-line--primary m-tabs-line--2x" role="tablist">
                      <li className="nav-item m-tabs__item">
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit`}
                        >
                          <i className="la la-info-circle" /> Basics
                        </NavLink>
                      </li>
                      <li className="nav-item m-tabs__item">
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/profilelimits`}
                        >
                          <i className="la la-calendar" /> Profile Limits
                          {registration.status.name === 'crewQuantityWaitingForApproval' && (
                            <span className="m-badge m-badge--warning m-badge--wide m--margin-left-10">
                              Needs Review
                            </span>
                          )}
                        </NavLink>
                      </li>
                      <li
                        className={statusDependendClassNames}
                        data-tip={
                          LimitsComplete ? '' : 'These options will be available after the planning has been approved'
                        }
                      >
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/crew`}
                        >
                          <i className="la la-users" /> Crew Members
                        </NavLink>
                      </li>
                      <li
                        className={statusDependendClassNames}
                        data-tip={
                          LimitsComplete ? '' : 'These options will be available after the planning has been approved'
                        }
                      >
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/catering`}
                        >
                          <i className="la la-cutlery" /> Catering
                        </NavLink>
                      </li>
                      <li
                        className={statusDependendClassNames}
                        data-tip={
                          LimitsComplete ? '' : 'These options will be available after the planning has been approved'
                        }
                      >
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/parking`}
                        >
                          <i className="la la-car" /> Parking Requests
                        </NavLink>
                      </li>
                      <li
                        className={statusDependendClassNames}
                        data-tip={
                          LimitsComplete ? '' : 'These options will be available after the planning has been approved'
                        }
                      >
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/parkingstickers`}
                        >
                          <i className="la la-car" /> Parking Stickers
                        </NavLink>
                      </li>
                      <li
                        className={statusDependendClassNames}
                        data-tip={
                          LimitsComplete ? '' : 'These options will be available after the planning has been approved'
                        }
                      >
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/access-vouchers`}
                        >
                          <i className="la la-barcode" /> Access Vouchers
                        </NavLink>
                      </li>
                      <li
                        className={statusDependendClassNames}
                        data-tip={
                          LimitsComplete ? '' : 'These options will be available after the planning has been approved'
                        }
                      >
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/parking-vouchers`}
                        >
                          <i className="la la-car" /> Parking Vouchers
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          exact
                          activeClassName="active"
                          className="nav-link m-tabs__link"
                          to={`/admin/registrations/${registration.id}/edit/frequent-passages`}
                        >
                          <i className="la la-truck" /> Frequent Passages
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <Route
                key="base"
                exact
                path="/admin/registrations/:id/edit"
                render={(routeProps) => (
                  <RegistrationBase
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="profileLimits"
                exact
                path="/admin/registrations/:id/edit/profilelimits"
                render={(routeProps) => (
                  <RegistrationProfileLimits
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="crewMembers"
                exact
                path="/admin/registrations/:id/edit/crew"
                render={(routeProps) => (
                  <RegistrationCrewMembers
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="crewMembersEdit"
                exact
                path="/admin/registrations/:id/edit/crew/:crewId/edit"
                render={(routeProps) => (
                  <RegistrationCrewMembers
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="catering"
                exact
                path="/admin/registrations/:id/edit/catering"
                render={(routeProps) => (
                  <RegistrationCatering
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="parking"
                exact
                path="/admin/registrations/:id/edit/parking"
                component={ListRegistrationParkingRequests}
              />

              <Route
                key="parkingstickers"
                exact
                path="/admin/registrations/:id/edit/parkingstickers"
                component={ListRegistrationParkingStickers}
                // render={(routeProps) => (
                //   <RegistrationParkingStickers
                //     {...routeProps}
                //     registration={registration}
                //     event={event}
                //     refreshRegistration={this._updateRegistration}
                //   />
                // )}
              />

              <Route
                key="accessvouchers"
                exact
                path="/admin/registrations/:id/edit/access-vouchers"
                render={(routeProps) => (
                  <RegistrationAccessVouchers
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="parkingvouchers"
                exact
                path="/admin/registrations/:id/edit/parking-vouchers"
                render={(routeProps) => (
                  <RegistrationParkingVouchers
                    {...routeProps}
                    registration={registration}
                    event={event}
                    refreshRegistration={this._updateRegistration}
                  />
                )}
              />

              <Route
                key="frequentPassages"
                exact
                path="/admin/registrations/:id/edit/frequent-passages"
                render={(routeProps) => <FrequentPassages registration={registration} />}
              />
            </div>
          </div>
        </Fragment>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = function (state, props) {
  return {
    event: selectEvent(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateRequest: (id, values) => dispatch(REGISTRATIONS_ACTIONS.updateRequest(id, values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationsEdit);
